import React, { useEffect, useRef, useState } from 'react';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CustomInput,
  Form,
  ModalFooter,
  Row,
} from 'reactstrap';
import { ProductImages } from '../../components/listings/ProductImages';
import { ProductImagesView } from '../../components/listings/ProductImagesView';
import { ButtonWithLoadingIcon } from '../../components/common/ButtonWithLoadingIcon';
import { Colxx } from '../../components/common/CustomBootstrap';
import { productEditingModes } from '../../constants/productApproval';
import { ProductDetailHeader } from '../../components/listings/ProductDetailHeader';
import { statusesData } from './statusesData';
import {
  getFormattedDateString,
  getFormattedMoneyString,
  getFormattedStatus,
  getFormattedStatusFirstCapital,
} from '../../helpers/utils';
import { Status } from '../../constants/status';
import { useUserContext } from '../../context/UserContext';
import { PDSection } from '../../components/common/PDSection';
import { BasicDetailItem } from '../../components/common/BasicDetailItem';
import StatusPill from '../../components/common/status-pill/StatusPill';
import { LinkButton } from '../../components/common/LinkButton';
import productAPI from '../../services/API/product';
import { CustomCheckBox } from '../../components/common/CustomFormComponents';
import { LoadingContainer } from '../../components/common/LoadingContainer';

export const ListingDetailsModalContent = ({
  productData = {},
  detailPageButtonStates,
  updateProductStatus,
  editingMode,
  deleteProduct,
  isSM,
  onCloseModal,
  updateProductDetails,
  isRental,
}) => {
  const [images, setImages] = useState([]); // product images
  const [selectedProduct, setSelectedProduct] = useState(productData);
  const [loading, setLoading] = useState(false);
  const [cancellingListing, setCancellingListing] = useState(false); // product images
  const [isEditForSale, setIsEditForSale] = useState(false); // product images
  const [forSale, setForSale] = useState(productData.for_sale); // product images
  const formikRef = useRef(null); // form ref
  const { user } = useUserContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // add new helper states
  const [clickedButtonIndex, setClickedButtonIndex] = useState('');
  const [activeIndex, setActiveIndex] = useState(null);
  const [targetStatus, setTargetStatus] = useState('');
  const [imageAddError, setImageAddError] = useState(null);

  useEffect(() => {
    const getProduct = async () => {
      try {
        setLoading(true);
        const productDataRes = await productAPI.getProductById(
          productData.id ? productData.id : productData.product_id
        );
        setSelectedProduct({
          ...productDataRes,
          status_display_user: productData.event,
        });
        setLoading(false);
      } catch {
        setLoading(false);
      }
    };
    if (isRental && productData) {
      getProduct();
    } else {
      setSelectedProduct(productData);
    }
  }, []);

  // handlers
  const handleFooterButtonClick = (buttonIndex, target) => {
    if (target === Status.deleted) {
      const data = {
        id: selectedProduct.id,
      };
      if (deleteProduct) {
        deleteProduct(buttonIndex, data);
      }
    } else if (editingMode === productEditingModes.ADD_NEW) {
      setClickedButtonIndex(buttonIndex);
      setTargetStatus(target);

      if (target === Status.draft_by_lender && images.length < 2) {
        setImageAddError('Please upload at least two images');
      } else {
        setImageAddError(null);
        if (formikRef.current) {
          formikRef.current.handleSubmit();
        }
      }
    } else {
      // will do update
      const data = {
        id: selectedProduct.id,
        status: target,
        user_id: user.id,
      };

      if (updateProductStatus) {
        updateProductStatus(buttonIndex, data);
      }
    }
  };

  let statusData =
    statusesData[
      selectedProduct?.status_display_user === 'Retired'
        ? selectedProduct?.status_display_user
        : selectedProduct.status ?? Status.unsaved
    ];

  // Show/Hide controlling flags
  const showProductStatus = editingMode !== productEditingModes.ADD_NEW;
  const showProductHeader = editingMode !== productEditingModes.ADD_NEW;
  const showStatusUpdateButtons =
    statusData && statusData.buttons && statusData.buttons.length > 0;
  //

  const handleProductCancelListing = async () => {
    const data = {
      product_id: selectedProduct.id,
    };
    setCancellingListing(true);
    try {
      await productAPI.cancelRental(data);
      setCancellingListing(false);
      if (onCloseModal) {
        onCloseModal();
      }
    } catch (error) {
      setCancellingListing(false);
    }
  };

  return (
    <Row>
      {loading ? (
        <LoadingContainer style={{ backgroundColor: 'transparent' }} />
      ) : (
        <Colxx xxs='12'>
          <Card
            className='mb-4 no-shadow common-product-list'
            style={{ backgroundColor: 'transparent' }}
          >
            <CardHeader
              className='px-0'
              style={{
                borderBottom: `1px solid #2E2B2B`,
                backgroundColor: 'transparent',
                paddingTop: '0.75rem',
              }}
            >
              <Row className='align-items-center'>
                <Colxx xxs='6'>
                  <div
                    style={{
                      textAlign: 'left',
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: 25,
                    }}
                  >
                    <span
                      style={{
                        color: 'black',
                        fontSize: 16,
                        fontFamily: 'Brown',
                        textAlign: 'right',
                      }}
                      // className='mr-3'
                    >
                      {`${isRental ? 'ID' : 'Listed on'} ${
                        isRental
                          ? selectedProduct?.barcode || selectedProduct?.id
                          : getFormattedDateString(selectedProduct.consigned_on)
                      }`}
                    </span>

                    {/* <strong
                    className='text-uppercase'
                    style={{ fontWeight: 'normal' }}
                  >
                    {productData.status
                      ? getFormattedStatus(
                          productData.status === Status.draft_by_lender
                            ? Status.draft
                            : productData.status
                        )
                      : ''}
                  </strong> */}
                  </div>
                </Colxx>
                <Colxx
                  xxs='6'
                  style={{
                    textAlign: 'right',
                    justifyContent: 'flex-end',
                    paddingRight: 0,
                  }}
                  className={'d-flex'}
                >
                  {selectedProduct.status_display_user ? (
                    <StatusPill
                      status={getFormattedStatus(
                        selectedProduct.status_display_user
                      )}
                      originalStatus={selectedProduct.status}
                      backgroundColor={
                        isRental &&
                        selectedProduct?.status_display_user === 'rented'
                          ? '#F9D7DB'
                          : selectedProduct?.status_display_user.toLowerCase() ===
                            'failed'
                          ? '#FF82A0'
                          : selectedProduct?.status_display_user.toLowerCase() ===
                            'retired'
                          ? '#E4D7F9'
                          : selectedProduct?.status_color_code_user || '#000000'
                      }
                    />
                  ) : (
                    '-'
                  )}
                </Colxx>
              </Row>
            </CardHeader>
            <CardBody
              className='px-0'
              style={{
                backgroundColor: 'transparent',
                paddingTop: '1rem',
                paddingBottom: '1rem',
                borderBottom: isRental ? `1px solid #2E2B2B` : null,
              }}
            >
              <Row>
                <Colxx xxs={isSM ? '12' : '4'}>
                  <ProductImagesView
                    productId={selectedProduct.id}
                    editingMode={editingMode}
                    imageAddError={imageAddError}
                    isAllowAddImage={
                      Object.keys(selectedProduct).length === 0
                        ? true
                        : selectedProduct.status === Status.draft_by_lender
                    }
                    isRental={isRental}
                    onImagesChanged={(imgs) => {
                      setImageAddError(null);
                      setImages(imgs);
                    }}
                  />
                </Colxx>
                <Colxx xxs={isSM ? '12' : '4'}>
                  <BasicDetailItem
                    label='Title'
                    value={
                      selectedProduct.title ||
                      selectedProduct?.data?.title ||
                      '-'
                    }
                  />
                  <BasicDetailItem
                    label='Category'
                    value={selectedProduct.category || '-'}
                  />
                  <BasicDetailItem
                    label='Price'
                    value={
                      selectedProduct.price
                        ? getFormattedMoneyString(selectedProduct.price)
                        : '-'
                    }
                  />
                  <BasicDetailItem
                    label='Brand'
                    value={
                      selectedProduct.brand ||
                      selectedProduct?.data?.brand ||
                      '-'
                    }
                  />
                  <BasicDetailItem
                    label='Size'
                    value={
                      selectedProduct.size || selectedProduct?.data?.size || '-'
                    }
                  />
                  <BasicDetailItem
                    label='Color'
                    value={
                      selectedProduct.color ||
                      selectedProduct?.data?.color ||
                      '-'
                    }
                  />
                  <BasicDetailItem
                    label='Description'
                    value={
                      selectedProduct.description ||
                      selectedProduct?.data?.description ||
                      '-'
                    }
                  />
                  {isRental ? (
                    <BasicDetailItem
                      label={`Renter's Insurance`}
                      value={
                        selectedProduct?.return_on_delisting ? 'Yes' : 'No'
                      }
                    />
                  ) : null}
                  <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <div
                      className={'mb-2'}
                      style={{
                        paddingTop: '0.35rem',
                        paddingBottom: '0.35rem',
                      }}
                    >
                      {productData.status !== Status.listed ? (
                        <BasicDetailItem
                          label={'For sale'}
                          value={selectedProduct?.for_sale ? 'Yes' : 'No'}
                        />
                      ) : (
                        <CustomCheckBox
                          title={'For sale'}
                          value={'forSale'}
                          name={'for_sale'}
                          id='for_sale'
                          checked={forSale}
                          onCheckChange={(value) => {
                            setForSale(value);
                            const values = {
                              brand: selectedProduct?.data?.brand ?? '',
                              category: selectedProduct?.category ?? '',
                              color: selectedProduct?.data?.color ?? 'black',
                              commission_percent:
                                selectedProduct?.store_commission_percent ?? '',
                              consigned_by_user_id:
                                selectedProduct?.consigned_by_user_id ?? 340,
                              consigned_on: selectedProduct?.consigned_on ?? '',
                              description:
                                selectedProduct?.data?.description ?? '',
                              for_sale: value,
                              return_on_delisting:
                                selectedProduct?.return_on_delisting ?? false,
                              gender: selectedProduct?.data?.gender ?? '',
                              price: selectedProduct?.price ?? 0,
                              rent_per_week:
                                selectedProduct?.rent_earnings_per_week ?? 0,
                              size: selectedProduct?.data?.size ?? '',
                              size_type: selectedProduct?.data?.size_type ?? '',
                              title: selectedProduct?.data?.title ?? '',
                            };
                            if (updateProductDetails) {
                              updateProductDetails(
                                values,
                                'buttonUpdate',
                                {},
                                true
                              );
                            }
                            setIsEditForSale(false);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </Colxx>
                <Colxx xxs={isSM ? '12' : '4'}>
                  {isRental ? (
                    <BasicDetailItem
                      label={'Rented On'}
                      value={getFormattedDateString(
                        selectedProduct.consigned_on
                      )}
                    />
                  ) : null}
                  {/* {selectedProduct && selectedProduct.status === 'listed' ? (
                    <div
                      style={{
                        flexDirection: 'column',
                        display: 'flex',
                        marginBottom: 50,
                      }}
                    >
                      <div className='capitalize mb-2'>
                        <LinkButton>
                          <a
                            href={selectedProduct.shopify_product_url}
                            className='btn-link'
                            color='link'
                            style={{ color: '#706F70' }}
                          >
                            See on Store
                          </a>
                        </LinkButton>
                      </div>
                    </div>
                  ) : null} */}
                </Colxx>
              </Row>
            </CardBody>
            {isRental ? null : (
              <CardFooter
                style={{
                  backgroundColor: 'transparent',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingTop: '2rem',
                  borderTop: `1px solid #2E2B2B`,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {statusData?.buttons?.map((statusButton, index) => {
                    const buttonId = statusButton.id;
                    return (
                      <ButtonWithLoadingIcon
                        key={buttonId}
                        className={`mb-2 ${
                          index === statusData?.buttons?.length - 1
                            ? 'mr-0'
                            : 'mr-3'
                        }`}
                        style={
                          productData.status === 'listed'
                            ? {
                                width: 260,
                                backgroundColor:
                                  index === activeIndex &&
                                  detailPageButtonStates?.updatingButton !== ''
                                    ? '#EFEB75'
                                    : null,
                                borderColor:
                                  index === activeIndex &&
                                  detailPageButtonStates?.updatingButton !== ''
                                    ? '#2E2B2B'
                                    : null,
                                color:
                                  index === activeIndex &&
                                  detailPageButtonStates?.updatingButton !== ''
                                    ? '#2E2B2B'
                                    : null,
                              }
                            : {
                                backgroundColor:
                                  index === activeIndex &&
                                  detailPageButtonStates?.updatingButton !== ''
                                    ? '#EFEB75'
                                    : null,
                                borderColor:
                                  index === activeIndex &&
                                  detailPageButtonStates?.updatingButton !== ''
                                    ? '#2E2B2B'
                                    : null,
                                color:
                                  index === activeIndex &&
                                  detailPageButtonStates?.updatingButton !== ''
                                    ? '#2E2B2B'
                                    : null,
                              }
                        }
                        disabled={detailPageButtonStates?.updatingButton !== ''}
                        loading={
                          detailPageButtonStates?.updatingButton === buttonId
                        }
                        color='primary'
                        onClick={() => {
                          setActiveIndex(index);
                          handleFooterButtonClick(
                            buttonId,
                            statusButton.target
                          );
                        }}
                      >
                        {statusButton.name}
                      </ButtonWithLoadingIcon>
                    );
                  })}
                </div>
                {productData.status === Status.applied_c ||
                productData.status === Status.listed ||
                productData.status === Status.rejected1_c ||
                productData.status === Status.rejected2_c ||
                productData.status_display_user !== 'Out on rent' ||
                productData.status === Status.shipped_c ? null : (
                  <LinkButton
                    className={'mt-3'}
                    onClick={() => {
                      // if (productData.status === Status.approved1_c) {
                      //   handleProductCancelListing();
                      // } else {
                      if (onCloseModal) {
                        onCloseModal();
                      }
                      // }
                    }}
                  >
                    Cancel
                  </LinkButton>
                )}
              </CardFooter>
            )}
          </Card>
        </Colxx>
      )}
    </Row>
  );
};
